import React from 'react';
import LoadingProfessor from '@/components/Lottie/LoadingProfessor';
import './style';

const Loading = () => (
  <div className="page-loading">
    <LoadingProfessor />
  </div>
);
export default Loading;
